import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
} from '@angular/router';
import { ActiveUserStore } from '../stores/user/active-user.state';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  readonly userStore = inject(ActiveUserStore);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    // Pass the target URL explicitly - window.location.pathname still
    // reflects the route being navigated AWAY from at this point.
    return this.userStore.checkAuthStatus(false, state.url);
  }

  // Child route guardian
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    return this.canActivate(route, state); // Reuse the same logic as `canActivate`
  }
}
